export const EventCodeMap = {
  // 公共
  '打开页面': 'open_page',
  '实时查询': 'search_realtime',
  '离线下载': 'download_offline',
  '搜索': 'search',
  '点击': 'click',
  '附件下载': 'download_attachment',
  '增加自定义列指标': 'custom_column_add',
  '减少自定义列指标': 'custom_column_reduce',
  '收藏': 'collect',
  '批量收藏': 'collect_batch',

  // 知识库
  '曝光数量V2': 'page_expose',
  '有视频': 'page_with_video',
  '停留时长': 'page_stay_time',
  '视频播放时长': 'video_play_time',
};

export const UNKNOWN_EVENT_CODE = 'unknown';
